/* import __COLOCATED_TEMPLATE__ from './about-auto-resizing-textarea-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();